import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutMe from "./components/AboutMe";
import GameHighlights from "./components/GameHighlights";
import LiveStreams from "./components/LiveStreams";
import SocialMedia from "./components/SocialMedia";
import AidanTetris from "./components/AidanTetris";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#07070f] font-rajdhani">
      <Navbar />
      <main>
        <Hero />
        <AboutMe />
        <GameHighlights />
        <LiveStreams />
        <SocialMedia />
        <AidanTetris />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
